import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  Button,
  CardList,
  IconList,
  Modal,
  NetworkStatus,
  Offline,
  BannerComponent,
} from 'common/components';
import * as constants from 'common/constants';
import {
  drawfields as DrawFieldsIcon,
  uploadzip as UploadZipIcon,
} from 'common/svg/icons';
import { getLatestDiary, capitalizeString } from 'common/utils';
import { base64url_encode } from 'util/base64';
import { toCommaNumber } from 'common/formatters';
import { offline as OfflineIcon } from 'common/svg/icons';

import './index.css';

// field list specific container
class FieldList extends Component {
  state = {
    showAddFieldModal: false,
  };

  renderContent(crop, idx) {
    let data = [
      {
        label: `${crop.crop.name} ${
          crop.crop.variety ? crop.crop.variety : ''
        }`,
        icon: 'crop',
      },
      {
        label: `${toCommaNumber(crop.plantedArea.size)} ${capitalizeString(
          crop.plantedArea.type
        )}`,
        icon: 'fields',
      },
    ];

    // for Diary Field, show only the last of array
    const expectedYield = getLatestDiary(crop.expectedYield);
    if (expectedYield) {
      data.push({
        label: `${toCommaNumber(expectedYield.yield.size)} ${capitalizeString(
          expectedYield.yield.type
        )}/${capitalizeString(expectedYield.yield.per)}`,
        icon: 'storagefill',
      });
    }

    return <IconList key={idx} list={data} />;
  }

  getContent = item => {
    return (
      <Fragment>
        <IconList
          list={[
            {
              label: `${toCommaNumber(item.size.size)} ${capitalizeString(
                item.size.type
              )}`,
              icon: 'fields',
            },
          ]}
        />
        {item.crops && item.crops.map(this.renderContent)}
      </Fragment>
    );
  };

  getCardData = item => ({
    title: item.name,
    content: this.getContent(item),
    link: `${constants.ROUTE_FIELDS_DETAIL}/${base64url_encode(
      item.name.trim()
    )}`,
  });

  render() {
    const { browser, fields, firstName, goToPage, settings } = this.props;
    const { showAddFieldModal } = this.state;
    if (!fields) {
      return null;
    }

    return (
      <Fragment>
        <Offline>
          <BannerComponent
            message="Some fields may not be available in offline mode."
            theme={['offline-short']}
            leftIcon={<OfflineIcon />}
          />
        </Offline>
        <NetworkStatus
          render={({ isOnline }) => (
            <Fragment>
              <CardList
                cards={fields.map(this.getCardData)}
                theme={['deco']}
                emptyStateconfig={{
                  message: "Let's begin by adding your fields.",
                  btnMessage: 'Add Field',
                  showAdd: isOnline,
                  firstName,
                  action: () => {
                    if (
                      browser.is.mobile ||
                      !settings.features.allowUploadShapefile
                    ) {
                      goToPage(constants.ROUTE_FIELDS_ADD);
                    } else {
                      this.setState({ showAddFieldModal: true });
                    }
                  },
                }}
              />
              {browser.greaterThan.mobile && showAddFieldModal && (
                <Modal
                  enableTopRightClose
                  header="Add new fields"
                  onToggle={() => this.setState({ showAddFieldModal: false })}
                >
                  <div className="addFieldOptions">
                    <div>
                      <p>Use a shape file to add multiple fields.</p>
                      <p>
                        <UploadZipIcon width="150" height="100" />
                      </p>
                      <Button
                        className="btn btn--primary btn--margin-below btn--auto"
                        onClick={() => goToPage(constants.ROUTE_FIELDS_UPLOAD)}
                      >
                        Upload shape file
                      </Button>
                      <p>
                        <a
                          href="https://support.agigrow.com/hc/en-us"
                          target="blank"
                          rel="noopener noreferrer"
                        >
                          Don’t have a shape file?
                        </a>
                      </p>
                    </div>
                    <hr />
                    <div>
                      <p>Draw your fields individually on the map.</p>
                      <p>
                        <DrawFieldsIcon width="150" height="100" />
                      </p>
                      <Button
                        className="btn btn--primary btn--margin-below btn--auto"
                        onClick={() => goToPage(constants.ROUTE_FIELDS_ADD)}
                      >
                        Draw fields
                      </Button>
                    </div>
                  </div>
                </Modal>
              )}
            </Fragment>
          )}
        />
      </Fragment>
    );
  }
}

FieldList.propTypes = {
  browser: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
  firstName: PropTypes.string.isRequired,
  goToPage: PropTypes.func,
  settings: PropTypes.object.isRequired,
};

const mapState = ({ auth: { firstName }, browser, settings }) => ({
  browser,
  firstName,
  settings,
});

const mapDispatch = {
  goToPage: routeName => push(routeName),
};

export default connect(
  mapState,
  mapDispatch
)(FieldList);



// WEBPACK FOOTER //
// ./src/containers/FieldList/index.js